// NavLinkContainer.js
import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { Link } from 'react-router-dom';


// Animação de flutuação
const floatAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

// Animação de "piscada" para o item ativo
const blinkAnimation = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

// Container do Link com a imagem de nuvem de fundo
const NavLinkContainerStyled = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 80px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  animation: ${floatAnimation} 3s ease-in-out infinite;

  ${({ isActive }) =>
    isActive &&
    css`
      animation: ${floatAnimation} 3s ease-in-out infinite, ${blinkAnimation} 0.5s linear infinite;
    `}
`;

// Estilo para o Link
const StyledLink = styled(Link)`
  text-decoration: none;
  font-size: 1.2em;
  color: black;
  position: relative;
  z-index: 1; /* O texto fica acima da nuvem */
  text-align: center;
  font-family: 'Comic Sans MS', cursive, sans-serif;
  
`;

// Componente principal
const NavLinkContainer = ({ link, isActive, handleLinkClick, label, to }) => (
  <NavLinkContainerStyled isActive={isActive}>
    {/* Link estilizado que navega para a rota */}
    <StyledLink to={to} onClick={() => handleLinkClick(link)}>
      {label}
    </StyledLink>
  </NavLinkContainerStyled>
);

export default NavLinkContainer;
